module.exports = __webpack_public_path__ + "static/scale-model-of-yul-brynner's-star-in-glendale-california-d8d64900aafd19458ce3e203cc399f93.png";